/** Rot → Gelb → Grün je nach Fortschritt, statt einer einzelnen Akzentfarbe für 0% und
 * 100% gleichermaßen — macht auf einen Blick sichtbar, wie weit eine Aufgabe wirklich ist.
 * Geteilt zwischen Fortschrittsbalken, Slider und Aufgaben-Karte, damit alle drei exakt
 * dieselbe Farbskala zeigen. */
export function progressColor(percent: number): string {
  const hue = Math.max(0, Math.min(100, percent)) * 1.2
  return `hsl(${hue}, 70%, 45%)`
}
